import useSelector from "@mittwald/flow-lib/dist/hooks/useSelector";
import sessionStore from "../store/session";

export const useAccessToken = (): string | undefined => {
  return useSelector(() => sessionStore.accessToken);
};

export default useAccessToken;
